import { useSandboxStore } from '@/stores/sandbox'
import { useSandboxDialogStore } from '@/stores/sandbox-dialog'

import { SandboxDialog } from '../sandbox-dialog'

/**
 * Global SandboxDialogProvider component
 * Renders the SandboxDialog based on the global sandbox dialog store state.
 * Should be rendered once at the root/app layout level.
 */
export function SandboxDialogProvider() {
  const isSandboxMode = useSandboxStore((s) => s.isSandboxMode)
  const isOpen = useSandboxDialogStore((s) => s.isOpen)
  const source = useSandboxDialogStore((s) => s.source)
  const setIsOpen = useSandboxDialogStore((s) => s.setIsOpen)

  if (!isSandboxMode) return null

  return (
    <SandboxDialog open={isOpen} onOpenChange={setIsOpen} source={source} />
  )
}
